export const trafficStatus = {};

export default trafficStatus;
